import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=4cf958f6&scoped=true&"
import script from "./Students.vue?vue&type=script&lang=js&"
export * from "./Students.vue?vue&type=script&lang=js&"
import style0 from "./Students.vue?vue&type=style&index=0&id=4cf958f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf958f6",
  null
  
)

export default component.exports